export default {
  SET_ONE_BRIGADE_WORKS(state, data) {
    state.brigade_works = data
  },
  SET_ALL_BRIGADE_WORKS(state, data) {
    state.all_brigade_works = data
  },
  
  
  
  SET_ONE_BRIGADE_WORK_CATEGORIES(state, data) {
    state.brigade_work_categories = data
  },
  SET_ALL_BRIGADE_WORK_CATEGORIES(state, data) {
    state.all_brigade_work_categories = data
  },
}
